import React, {useEffect, useState} from 'react';
import Operations from "../../enums/Operations"
import PropTypes from 'prop-types';
import Table from "./Table"
import TableTypes from "../../enums/TableTypes";
import restUtil from "../../utils/RestUtil";
import {faEdit, faTrash} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import generalUtil from "../../utils/GeneralUtil";
import Modal from "../ModalForm/Modal";

const propTypes = {
    axios: PropTypes.func.isRequired
};

const columns = [
    {
        dataField: 'email_group_id',
        text: 'Email Group Id',
        sort: true
    },
    {
        dataField: 'name',
        text: 'Name',
        sort: true
    },
    {
        dataField: 'distribution_email',
        text: 'Distribution Email'
    },
    {
        dataField: 'default_email_group',
        text: 'Default Email Group'
    }, {
        dataField: 'edit_and_delete',
        text: 'Edit and Delete'
    }
];

const defaultSorted = [{
    dataField: 'name',
    order: 'asc'
}];

// This component contains the information to build a table from json data
const EmailGroupTable = props => {
    const [entries, setEntries] = useState([]);
    const [updateEmailGroupModalIsShown, setUpdateEmailGroupModalIsShown] = useState(false);
    const [deleteEmailGroupModalIsShown, setDeleteEmailGroupModalIsShown] = useState(false);
    const [selectedEmailGroupId, setSelectedEmailGroupId] = useState(null);

    useEffect(() => {
        props.axios.get('/sevbot/emailGroups/allEmailGroups')
        .then((result) => {
            setEntries(result.data);
        }).catch(function (error) {
            console.log(error);
        })
    }, [props.axios]);

    // Cleans the data returned from the database for usage in the table
    const getCleanData = () => {
        let cleanedEntries = structuredClone(entries);

        if (cleanedEntries !== null && cleanedEntries !== undefined) {
            for (let i = 0; i < cleanedEntries.length; i++) {
                let tableEntry = cleanedEntries.at(i);
                tableEntry['entry_id'] = tableEntry['email_group_id'];
                tableEntry['edit_and_delete'] =
                    <td key={`edit_and_delete${tableEntry['entry_id']}`}>
                        <FontAwesomeIcon icon={faEdit} className={"icon-button"}onClick={() => showUpdateEmailGroupModal(tableEntry['entry_id'])}/>
                        <FontAwesomeIcon icon={faTrash} className={"icon-button"}onClick={() => showDeleteEmailGroupModal(tableEntry['entry_id'])}/>
                    </td>
            }
        }
        return cleanedEntries;
    }

    // Handles submission of form for updating email group
    const updateEmailGroupOnSubmit = (event) => {
        event.preventDefault(event);
        let data = {
            id: event.target.id.value,
            name: event.target.name.value,
            email: event.target.email.value,
            defaultEmailGroup: event.target.defaultEmailGroup.checked
        }
        restUtil.putRequest(props.axios, '/sevbot/emailGroups/updateEmailGroup', data);
    }

    // Handles submission of email group deletion form
    const deleteEmailGroupOnSubmit = (event) => {
        let data = {id: event.target.id.value};
        restUtil.deleteRequest(props.axios, '/sevbot/emailGroups/deleteEmailGroup', data);
    }

    const showUpdateEmailGroupModal = (tableRowId) => {
        setUpdateEmailGroupModalIsShown(true);
        setSelectedEmailGroupId(tableRowId);
        generalUtil.toggleScrollLock();
    };

    const closeUpdateEmailGroupModal = () => {
        setUpdateEmailGroupModalIsShown(false);
        generalUtil.toggleScrollLock();
    };

    const showDeleteEmailGroupModal = (tableRowId) => {
        setDeleteEmailGroupModalIsShown(true);
        setSelectedEmailGroupId(tableRowId);
        generalUtil.toggleScrollLock();
    };

    const closeDeleteEmailGroupModal = () => {
        setDeleteEmailGroupModalIsShown(false);
        generalUtil.toggleScrollLock();
    };

    return (
        <React.Fragment>
            {/* The Email Groups Table */}
            <Table
                data={getCleanData()}
                columns={columns}
                defaultSorted={defaultSorted}
                keyField={'email_group_id'}
            />
            {/* The Update Modal for updating an email group */}
            {updateEmailGroupModalIsShown ? (<Modal
                onSubmit={updateEmailGroupOnSubmit}
                closeModal={closeUpdateEmailGroupModal}
                onKeyDown={generalUtil.onKeyDown}
                tableType={TableTypes.EmailGroups}
                operation={Operations.Update}
                axios={props.axios}
                id={selectedEmailGroupId}
            />) : null}
            {/* The Delete Modal for deleting an email group */}
            {deleteEmailGroupModalIsShown ? (<Modal
                onSubmit={deleteEmailGroupOnSubmit}
                closeModal={closeDeleteEmailGroupModal}
                onKeyDown={generalUtil.onKeyDown}
                tableType={TableTypes.EmailGroups}
                operation={Operations.Delete}
                axios={props.axios}
                id={selectedEmailGroupId}
            />) : null}
        </React.Fragment>
    );
}

EmailGroupTable.propTypes = propTypes;
export default EmailGroupTable;
